import { getLabradorBackendUrl } from './getLabradorBackendUrl';

export function getBackendImageServer(trailingSlash = true) {
  if (getLabradorBackendUrl().includes('labrador.aller.se')) {
    return `https://image-labrador.aller.se` + (trailingSlash ? '/' : '');
  }
  return `https://image-allas-stage.labradorcms.io` + (trailingSlash ? '/' : '');
}
